(function() {
  "use strict";

  function toggleTheme() {
    document.documentElement.classList.toggle("dark");
    localStorage.setItem(
      "theme",
      document.documentElement.classList.contains("dark") ? "dark" : "light"
    );
  }

  function initThemeToggle() {
    document.querySelectorAll("[data-toggle-theme]").forEach(function(button) {
      button.addEventListener("click", toggleTheme);
    });
  }

  function initMobileNav() {
    var toggle = document.querySelector("[data-mobile-nav-toggle]");
    var nav = document.querySelector("[data-mobile-nav]");

    if (!toggle || !nav) {
      return;
    }

    toggle.addEventListener("click", function() {
      var isOpen = nav.classList.toggle("is-open");
      toggle.setAttribute("aria-expanded", isOpen ? "true" : "false");
    });
  }

  function initAccordions() {
    document.querySelectorAll("[data-faq-button]").forEach(function(button) {
      button.addEventListener("click", function() {
        var item = button.closest("[data-faq-item]");
        if (!item) {
          return;
        }

        var group = item.parentElement;
        var isOpen = !item.classList.contains("is-open");

        if (group) {
          group.querySelectorAll("[data-faq-item].is-open").forEach(function(openItem) {
            if (openItem !== item) {
              openItem.classList.remove("is-open");
              var openButton = openItem.querySelector("[data-faq-button]");
              if (openButton) {
                openButton.setAttribute("aria-expanded", "false");
              }
            }
          });
        }

        item.classList.toggle("is-open", isOpen);
        button.setAttribute("aria-expanded", isOpen ? "true" : "false");
      });
    });
  }

  function initFeatureSlider() {
    document.querySelectorAll("[data-feature-slider]").forEach(function(slider) {
      var track = slider.querySelector("[data-feature-track]");
      var dots = slider.querySelectorAll("[data-feature-dot]");

      if (!track || dots.length === 0) {
        return;
      }

      var currentIndex = 0;
      var timer = null;

      function goToSlide(index) {
        currentIndex = index;
        track.style.transform = "translateX(-" + (index * 100) + "%)";

        dots.forEach(function(dot, dotIndex) {
          dot.classList.toggle("is-active", dotIndex === index);
          dot.setAttribute("aria-pressed", dotIndex === index ? "true" : "false");
        });
      }

      function startAutoplay() {
        stopAutoplay();
        timer = window.setInterval(function() {
          goToSlide((currentIndex + 1) % dots.length);
        }, 3200);
      }

      function stopAutoplay() {
        if (timer) {
          window.clearInterval(timer);
        }
      }

      dots.forEach(function(dot, index) {
        dot.addEventListener("click", function() {
          goToSlide(index);
          startAutoplay();
        });
      });

      goToSlide(0);
      startAutoplay();
    });
  }

  function initProductGallery() {
    document.querySelectorAll("[data-product-gallery]").forEach(function(gallery) {
      var panes = gallery.querySelectorAll("[data-media-pane]");
      var thumbs = gallery.querySelectorAll("[data-media-thumb]");
      var prev = gallery.querySelector("[data-gallery-prev]");
      var next = gallery.querySelector("[data-gallery-next]");
      var currentIndex = 0;

      if (!panes.length) {
        return;
      }

      function activateByIndex(index) {
        currentIndex = (index + panes.length) % panes.length;
        var activePane = panes[currentIndex];
        var targetId = activePane.getAttribute("data-media-pane");

        panes.forEach(function(pane) {
          pane.classList.toggle("is-active", pane.getAttribute("data-media-pane") === targetId);
        });

        thumbs.forEach(function(thumb) {
          var isActive = thumb.getAttribute("data-media-target") === targetId;
          thumb.classList.toggle("is-active", isActive);
          thumb.setAttribute("aria-pressed", isActive ? "true" : "false");
        });
      }

      thumbs.forEach(function(thumb) {
        thumb.addEventListener("click", function() {
          var targetId = thumb.getAttribute("data-media-target");
          panes.forEach(function(pane, index) {
            if (pane.getAttribute("data-media-pane") === targetId) {
              activateByIndex(index);
            }
          });
        });
      });

      if (prev) {
        prev.addEventListener("click", function() {
          activateByIndex(currentIndex - 1);
        });
      }

      if (next) {
        next.addEventListener("click", function() {
          activateByIndex(currentIndex + 1);
        });
      }

      activateByIndex(0);
    });
  }

  function initCartAutoUpdate() {
    var form = document.querySelector("[data-cart-form]");

    if (!form) {
      return;
    }

    var timer = null;
    var quantityInputs = form.querySelectorAll("[data-cart-quantity]");

    function submitUpdate() {
      if (typeof form.requestSubmit === "function") {
        form.requestSubmit();
      } else {
        form.submit();
      }
    }

    quantityInputs.forEach(function(input) {
      input.addEventListener("input", function() {
        if (timer) {
          window.clearTimeout(timer);
        }

        timer = window.setTimeout(function() {
          submitUpdate();
        }, 800);
      });

      input.addEventListener("change", function() {
        if (timer) {
          window.clearTimeout(timer);
        }

        timer = window.setTimeout(function() {
          submitUpdate();
        }, 250);
      });
    });

    form.addEventListener("submit", function() {
      if (timer) {
        window.clearTimeout(timer);
      }
    });
  }

  function initReveal() {
    var elements = document.querySelectorAll(".reveal");

    if (document.documentElement.classList.contains("shopify-design-mode") || document.body.classList.contains("shopify-design-mode")) {
      elements.forEach(function(element) {
        element.classList.add("is-visible");
      });
      return;
    }

    if (!("IntersectionObserver" in window)) {
      elements.forEach(function(element) {
        element.classList.add("is-visible");
      });
      return;
    }

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-visible");
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });

    elements.forEach(function(element) {
      observer.observe(element);
    });
  }

  function parseCountValue(rawValue) {
    var match = String(rawValue).match(/^([^0-9]*)([0-9.,]+)(.*)$/);
    if (!match) {
      return null;
    }

    return {
      prefix: match[1] || "",
      number: parseInt(match[2].replace(/[^0-9]/g, ""), 10),
      suffix: match[3] || ""
    };
  }

  function formatCountValue(value) {
    return value.toLocaleString("nl-NL");
  }

  function initCounters() {
    var counters = document.querySelectorAll("[data-count-up]");

    if (!counters.length) {
      return;
    }

    function animateCounter(element) {
      var parsed = parseCountValue(element.getAttribute("data-count-up"));

      if (!parsed || !parsed.number) {
        return;
      }

      var duration = 1600;
      var startTime = null;
      element.classList.add("is-counting");

      function step(timestamp) {
        if (!startTime) {
          startTime = timestamp;
        }

        var progress = Math.min((timestamp - startTime) / duration, 1);
        var eased = 1 - Math.pow(1 - progress, 3);
        var current = Math.round(parsed.number * eased);

        element.textContent = parsed.prefix + formatCountValue(current) + parsed.suffix;

        if (progress < 1) {
          window.requestAnimationFrame(step);
        } else {
          element.textContent = parsed.prefix + formatCountValue(parsed.number) + parsed.suffix;
          element.classList.remove("is-counting");
        }
      }

      window.requestAnimationFrame(step);
    }

    if (!("IntersectionObserver" in window)) {
      counters.forEach(animateCounter);
      return;
    }

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          animateCounter(entry.target);
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.4 });

    counters.forEach(function(counter) {
      observer.observe(counter);
    });
  }

  function initBeforeAfter() {
    document.querySelectorAll("[data-before-after]").forEach(function(section) {
      var range = section.querySelector("[data-before-after-range]");
      var after = section.querySelector("[data-before-after-after]");
      var handle = section.querySelector("[data-before-after-handle]");

      if (!range || !after || !handle) {
        return;
      }

      function updatePosition() {
        var value = range.value + "%";
        after.style.clipPath = "inset(0 0 0 " + value + ")";
        handle.style.left = value;
      }

      range.addEventListener("input", updatePosition);
      updatePosition();
    });

    document.querySelectorAll("[data-before-after-slider]").forEach(function(slider) {
      var slides = slider.querySelectorAll("[data-before-after-slide]");
      var prev = slider.querySelector("[data-before-after-prev]");
      var next = slider.querySelector("[data-before-after-next]");
      var dots = slider.querySelectorAll("[data-before-after-dot]");
      var currentIndex = 0;

      if (!slides.length) {
        return;
      }

      function goToSlide(index) {
        currentIndex = (index + slides.length) % slides.length;

        slides.forEach(function(slide, slideIndex) {
          slide.classList.toggle("is-active", slideIndex === currentIndex);
        });

        dots.forEach(function(dot, dotIndex) {
          dot.classList.toggle("is-active", dotIndex === currentIndex);
          dot.setAttribute("aria-pressed", dotIndex === currentIndex ? "true" : "false");
        });
      }

      if (prev) {
        prev.addEventListener("click", function() {
          goToSlide(currentIndex - 1);
        });
      }

      if (next) {
        next.addEventListener("click", function() {
          goToSlide(currentIndex + 1);
        });
      }

      dots.forEach(function(dot, index) {
        dot.addEventListener("click", function() {
          goToSlide(index);
        });
      });

      goToSlide(0);
    });
  }

  function getThemeLanguageData() {
    var element = document.getElementById("theme-language-data");
    if (!element) {
      return null;
    }

    try {
      return JSON.parse(element.textContent);
    } catch (error) {
      return null;
    }
  }

  function getValueByPath(object, path) {
    return path.split(".").reduce(function(result, key) {
      if (result && Object.prototype.hasOwnProperty.call(result, key)) {
        return result[key];
      }
      return null;
    }, object);
  }

  function detectPreferredLanguage() {
    var stored = localStorage.getItem("tonigain-language");
    if (stored === "nl" || stored === "en") {
      return stored;
    }

    var languages = [];
    if (navigator.languages && navigator.languages.length) {
      languages = navigator.languages.slice();
    } else if (navigator.language) {
      languages = [navigator.language];
    }

    var combined = languages.join(",").toLowerCase();
    if (combined.indexOf("-nl") !== -1 || combined.indexOf("nl-") !== -1 || combined.indexOf("-be") !== -1 || combined.indexOf("be-") !== -1 || combined.indexOf("nl") === 0) {
      return "nl";
    }

    try {
      if (Intl.DateTimeFormat().resolvedOptions().timeZone === "Europe/Amsterdam") {
        return "nl";
      }
    } catch (error) {
      // Ignore timezone detection failures.
    }

    return "en";
  }

  function updateMetaTags(languageData, locale) {
    if (!languageData || !languageData.meta) {
      return;
    }

    var body = document.body;
    var pageType = body.getAttribute("data-page-type");
    var shopName = body.getAttribute("data-shop-name") || "ToniGain";
    var defaultDescription = languageData.meta.default_description || body.getAttribute("data-default-description-" + locale) || "";
    var productHandle = body.getAttribute("data-product-handle");
    var metaTitle = document.querySelector('meta[property="og:title"]');
    var metaDescription = document.querySelector('meta[name="description"]');
    var ogDescription = document.querySelector('meta[property="og:description"]');
    var twitterDescription = document.querySelector('meta[name="twitter:description"]');
    var twitterTitle = document.querySelector('meta[name="twitter:title"]');
    var title = document.title;

    if (pageType === "product" && productHandle && languageData.products && languageData.products[productHandle]) {
      var productData = languageData.products[productHandle];
      var translatedTitle = productData.title || title;
      title = translatedTitle + " | " + shopName;
      defaultDescription = (productData.cardDescription || defaultDescription).replace(/<[^>]+>/g, "");
    } else if (pageType === "index") {
      title = shopName + " | FiveM Store";
    } else if (pageType === "collection") {
      title = shopName + " | " + (locale === "nl" ? "Collectie" : "Collection");
    }

    document.title = title;

    if (metaTitle) {
      metaTitle.setAttribute("content", title);
    }
    if (twitterTitle) {
      twitterTitle.setAttribute("content", title);
    }
    if (metaDescription) {
      metaDescription.setAttribute("content", defaultDescription);
    }
    if (ogDescription) {
      ogDescription.setAttribute("content", defaultDescription);
    }
    if (twitterDescription) {
      twitterDescription.setAttribute("content", defaultDescription);
    }
  }

  function applyGenericTranslations(languageData) {
    document.querySelectorAll("[data-i18n]").forEach(function(element) {
      var path = element.getAttribute("data-i18n");
      var value = getValueByPath(languageData, path);
      if (typeof value === "string") {
        element.textContent = value;
      }
    });

    document.querySelectorAll("[data-i18n-html]").forEach(function(element) {
      var path = element.getAttribute("data-i18n-html");
      var value = getValueByPath(languageData, path);
      if (typeof value === "string") {
        element.innerHTML = value;
      }
    });

    document.querySelectorAll("[data-i18n-aria-label]").forEach(function(element) {
      var path = element.getAttribute("data-i18n-aria-label");
      var value = getValueByPath(languageData, path);
      if (typeof value === "string") {
        element.setAttribute("aria-label", value);
      }
    });
  }

  function applyIndexedTranslations(languageData) {
    var stats = (languageData.stats && languageData.stats.labels) || [];
    document.querySelectorAll("[data-stat-label]").forEach(function(element) {
      var index = parseInt(element.getAttribute("data-stat-label"), 10);
      if (typeof stats[index] === "string") {
        element.textContent = stats[index];
      }
    });

    var aboutMetrics = (languageData.stats && languageData.stats.labels) || [];
    document.querySelectorAll("[data-about-metric-label]").forEach(function(element) {
      var index = parseInt(element.getAttribute("data-about-metric-label"), 10);
      if (typeof aboutMetrics[index] === "string") {
        element.textContent = aboutMetrics[index];
      }
    });

    var features = (languageData.features && languageData.features.items) || [];
    document.querySelectorAll("[data-feature-title]").forEach(function(element) {
      var index = parseInt(element.getAttribute("data-feature-title"), 10);
      if (features[index] && features[index].title) {
        element.textContent = features[index].title;
      }
    });
    document.querySelectorAll("[data-feature-description]").forEach(function(element) {
      var index = parseInt(element.getAttribute("data-feature-description"), 10);
      if (features[index] && features[index].description) {
        element.textContent = features[index].description;
      }
    });

    var faqItems = (languageData.faq && languageData.faq.items) || [];
    document.querySelectorAll("[data-faq-question]").forEach(function(element) {
      var index = parseInt(element.getAttribute("data-faq-question"), 10);
      if (faqItems[index] && faqItems[index].question) {
        element.textContent = faqItems[index].question;
      }
    });
    document.querySelectorAll("[data-faq-answer]").forEach(function(element) {
      var index = parseInt(element.getAttribute("data-faq-answer"), 10);
      if (faqItems[index] && faqItems[index].answer) {
        element.innerHTML = faqItems[index].answer;
      }
    });
  }

  function applyProductTranslations(languageData) {
    var products = languageData.products || {};

    document.querySelectorAll("[data-product-handle]").forEach(function(card) {
      var handle = card.getAttribute("data-product-handle");
      var productData = products[handle];

      if (!productData) {
        return;
      }

      var title = card.querySelector("[data-product-title]");
      var description = card.querySelector("[data-product-description]");
      var badge = card.querySelector("[data-product-badge]");

      if (title && productData.title) {
        title.textContent = productData.title;
      }
      if (description) {
        if (card.closest(".product-layout") && productData.productDescription) {
          description.innerHTML = productData.productDescription;
        } else if (productData.cardDescription) {
          description.textContent = productData.cardDescription;
        }
      }
      if (badge && languageData.featured_products && languageData.featured_products.badge_popular) {
        badge.textContent = languageData.featured_products.badge_popular;
      }
    });
  }

  function bindLanguageSwitcher(currentLocale, setLocale) {
    document.querySelectorAll("[data-language-option]").forEach(function(button) {
      var locale = button.getAttribute("data-language-option");
      button.classList.toggle("is-active", locale === currentLocale);
      button.setAttribute("aria-pressed", locale === currentLocale ? "true" : "false");

      button.addEventListener("click", function() {
        setLocale(locale);
      });
    });
  }

  function initLanguageSystem() {
    var translations = getThemeLanguageData();
    if (!translations) {
      return;
    }

    function applyLocale(locale) {
      var languageData = translations[locale] || translations.nl;
      document.documentElement.setAttribute("lang", locale);
      document.documentElement.setAttribute("data-language", locale);
      localStorage.setItem("tonigain-language", locale);

      applyGenericTranslations(languageData);
      applyIndexedTranslations(languageData);
      applyProductTranslations(languageData);
      updateMetaTags(languageData, locale);

      document.dispatchEvent(new CustomEvent("tonigain:languagechange", {
        detail: {
          locale: locale,
          languageData: languageData
        }
      }));

      document.querySelectorAll("[data-language-option]").forEach(function(button) {
        var isActive = button.getAttribute("data-language-option") === locale;
        button.classList.toggle("is-active", isActive);
        button.setAttribute("aria-pressed", isActive ? "true" : "false");
      });
    }

    var preferredLanguage = detectPreferredLanguage();
    bindLanguageSwitcher(preferredLanguage, applyLocale);
    applyLocale(preferredLanguage);
  }

  document.addEventListener("DOMContentLoaded", function() {
    initLanguageSystem();
    initThemeToggle();
    initMobileNav();
    initAccordions();
    initFeatureSlider();
    initProductGallery();
    initCartAutoUpdate();
    initBeforeAfter();
    initReveal();
    initCounters();
  });
})();
